/**
 * LibrariesSection — generic "libraries" block that reuses the
 * FeaturedLibrariesSection card grid.
 *
 * Contract: same shape as the legacy featuredLibraries type —
 *   eyebrow, title, subtitle, library_ids  (admin-picked list)
 *
 * Dynamic injection (from MarketingPage.dynamicPropsFor):
 *   libraries  Array   — server-resolved list (or live fallback)
 *   loading    bool
 *
 * The backend resolves admin-picked library_ids and returns them in
 * featuredLibraries[section.id] — MarketingPage injects them as { libraries, loading }.
 * This component only consumes { libraries, loading, eyebrow, title, subtitle }.
 *
 * Renders nothing when libraries is empty and loading is false.
 */

import React from 'react';
import PropTypes from 'prop-types';
import FeaturedLibrariesSection from '../FeaturedLibrariesSection';

export default function LibrariesSection({ libraries, loading, eyebrow, title, subtitle }) {
  // Delegate entirely to the battle-tested FeaturedLibrariesSection.
  // Pass through all header props but NO default text — that lives in FeaturedLibrariesSection's
  // defaultProps which we deliberately bypass by forwarding what the admin provided.
  return (
    <FeaturedLibrariesSection
      libraries={libraries}
      loading={loading}
      eyebrow={eyebrow}
      title={title}
      subtitle={subtitle}
    />
  );
}

LibrariesSection.propTypes = {
  /** Injected by MarketingPage from server-resolved pinned libraries or dynamic top-libraries */
  libraries: PropTypes.array,
  loading: PropTypes.bool,
  /** Admin-editable header content */
  eyebrow: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  /** Stored in layout for backend resolution; not used directly by this component */
  library_ids: PropTypes.arrayOf(PropTypes.string),
};

LibrariesSection.defaultProps = {
  libraries: [],
  loading: false,
};
